export default __webpack_public_path__ + "static/media/newlogos.d41ae8b4.png";